// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"579":"d135effc","707":"e5d6ae0a","889":"b446e2dd","931":"643e15ed"}[chunkId] + ".chunk.js";
};